import React from 'react'

export default function ImageElement({ content }) {
  const url = process.env.REACT_APP_BACKEND_HOST + content
  return <img alt="" src={url} style={{maxHeight: 300, maxWidth: 300}} />
}